import React from 'react';
import { reduxForm, Field } from 'redux-form';

import Spinner from '../../components/Spinner';
import InputField from '../InputField';
import FormError from '../FormError';
import SelectField from 'components/SelectField';
import CheckboxField from 'components/CheckboxField';
import { formatSaveStatus } from 'helpers/formatters';

class CreateCreditForm extends React.Component {
  render() {
    const { handleSubmit, saveStatus, error, categories, loading } = this.props;
    const categoriesOptions = categories.map((cat) => [
      cat.value,
      cat.display_name,
    ]);

    return (
      <div className="relative">
        <form onSubmit={handleSubmit}>
          <Field component={InputField} name="user_profile" />
          <Field component={InputField} name="description" />
          <Field component={InputField} name="credit_owed" />
          <Field
            label="Category"
            component={SelectField}
            name="credit_type"
            options={categoriesOptions}
            empty="Select category"
          />
          <Field component={InputField} name="att_subscription_id" />
          <Field component={InputField} name="quick_subscription_id" />
          <Field component={InputField} name="simo_subscription_id" />
          <Field component={CheckboxField} name="upcoming" />

          <div className="mar-t">
            <button
              className="btn btn-default"
              disabled={loading}
              type="submit"
            >
              Create Credit
            </button>
            <span className="submit-status">
              {formatSaveStatus(saveStatus)}
            </span>
            {error && <FormError error={error} />}
          </div>
        </form>
        <Spinner showLoader={loading} />
      </div>
    );
  }
}

const validate = (values) => {
  let errors = {};

  const requiredFields = [
    'user_profile',
    'description',
    'credit_owed',
    'credit_type',
  ];

  requiredFields.forEach((fieldKey) => {
    if (!values[fieldKey]) {
      errors[fieldKey] = 'Required';
    }
  });

  return errors;
};

CreateCreditForm = reduxForm({
  form: 'createCredit',
  validate,
})(CreateCreditForm);

export default CreateCreditForm;
